export enum QuoteTimeRange {
  INTRADAY = 'INTRADAY',
  DAILY = 'DAILY',
  FIVE_DAYS = 'FIVE_DAYS',
  MONTHLY = 'MONTHLY',
  THREE_MONTHS = 'THREE_MONTHS',
  YEAR_TO_DATE = 'YEAR_TO_DATE',
  YEARLY = 'YEARLY',
  THREE_YEARS = 'THREE_YEARS',
  FIVE_YEARS = 'FIVE_YEARS',
  TEN_YEARS = 'TEN_YEARS',
  TWENTY_YEARS = 'TWENTY_YEARS'
}

